import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../utils/dateUtils';
import i18n from 'i18next'; // ← 追加

import { getSafeText} from '../../utils/valueResolver';

function AccordionItem({ date, details = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const lang = i18n.language;

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
      <button className="accordion-header" onClick={toggleOpen}>
        <span className="date">{formatDate(date)}</span>
        <div className="icon-toggle"></div>
      </button>
      {isOpen && (
        <div className="accordion-content">
          {details.length > 0 ? (
            <dl className="content-list">
              {details.map((detail, index) => (
                <div className="list-row" key={index}>
                  <dt>{getSafeText(detail.label, lang)}</dt>
                  <dd>{getSafeText(detail.value, lang)}</dd> {/* ← ここが重要！ */}
                </div>
              ))}
            </dl>
          ) : (
            <p className="no-details">{t('accordionItem.noDetails')}</p>
          )}
        </div>
      )}
    </div>
  );
}

export default AccordionItem;
